import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Container = styled.div`
  background-color: #e4e4e4;
  padding: 1rem;
  position: relative;
  margin-bottom: 1rem;
`

export const Icon = styled(FontAwesomeIcon)`
  color: rgb(100, 100, 105);
  font-size: 14px;
  line-height: 1;
  position: absolute;
  top: 1rem;
  left: 1rem;
`
export const Heading = styled.h5`
  font-size: 14px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0.5rem;
  padding-left: 1.5rem;
`

export const Message = styled.p`
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  padding-left: 1.5rem;

  a {
    color: ${({ theme }) => theme.colors.inverseColor};
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  }
`
